import React from "react";
import { UserFilter } from "../../../../../ts/App/Analytics/Common";
import { Container } from "./UserFilters.styles";
import { ClickableCross } from "./FilterCriteria.styles";

interface IFilterComponentProps {
  name?: string;
  labels?: string[];
  onRemoveLabelAndCondition?: (index: number) => () => void;
}

interface IClickableLabelProps {
  labels?: string[];
  onRemoveLabelAndCondition?: (index: number) => () => void;
}

export const getComponentForDisplay = (
  name: string,
  type: UserFilter,
  labels: string[],
  onRemoveLabelAndCondition: (index: number) => () => void
) => {
  const filterComponents = {
    [UserFilter.MarkedInTable]: <UsersSelectedInTable />,
    [UserFilter.TimeTakenBetween]: <TimeTakenBetween name={name} labels={labels} />,
    [UserFilter.AssessmentState]: (
      <AssessmentState name={name} labels={labels} onRemoveLabelAndCondition={onRemoveLabelAndCondition} />
    ),
    [UserFilter.TookTopic]: (
      <TookTopics name={name} labels={labels} onRemoveLabelAndCondition={onRemoveLabelAndCondition} />
    ),
  };
  return filterComponents[type] || <NameMatches labels={labels} />;
};

const UsersSelectedInTable: React.FC<IFilterComponentProps> = () => (
  <div data-testid="users-selected-in-table">
    {"Learner"}
    <strong>{" is marked in table"}</strong>
  </div>
);

const NameMatches: React.FC<IFilterComponentProps> = ({ labels }) => (
  <div>
    {"Learner matches"}
    {` matches "${labels![0]}"`}
  </div>
);

const TimeTakenBetween: React.FC<IFilterComponentProps> = ({ name, labels }) => (
  <div>
    {"Learner took "}
    <strong>{` between ${labels![0]} and ${labels![1]}`}</strong>
    {` to complete the ${name}. `}
  </div>
);

const ClickableLabels: React.FC<IClickableLabelProps> = ({ labels, onRemoveLabelAndCondition }) => {
  if (labels!.length === 1) {
    return <strong>{labels![0] + " "}</strong>;
  }
  return (
    <>
      {labels!.map((label, index) => (
        <Container key={`label-${index}`}>
          &nbsp;<strong>{label}</strong> &nbsp;
          <ClickableCross onClick={onRemoveLabelAndCondition!(index)} data-testid="label-clickable-cross" />
          &nbsp;{index !== labels!.length - 1 && <strong>{" or "}</strong>}
        </Container>
      ))}
    </>
  );
};

const AssessmentState: React.FC<IFilterComponentProps> = ({ name, labels, onRemoveLabelAndCondition }) => (
  <Container>
    {"Learner has"}
    &nbsp;
    <ClickableLabels labels={labels} onRemoveLabelAndCondition={onRemoveLabelAndCondition} />
    &nbsp;
    {`in this ${name}.`}
  </Container>
);
const TookTopics: React.FC<IFilterComponentProps> = ({ name, labels, onRemoveLabelAndCondition }) => (
  <Container>
    {"Learner received"}
    &nbsp;
    <ClickableLabels labels={labels} onRemoveLabelAndCondition={onRemoveLabelAndCondition} />
    &nbsp;
    {`lessons in ${name}.`}
  </Container>
);
